import { Link } from "react-router-dom";

const steps = [
  {
    number: "01",
    icon: "🔍",
    title: "Browse Plans",
    description:
      "Explore our catalog of professionally designed architectural plans. Filter by type, bedrooms, or style to find your perfect match.",
    cta: { label: "View Plans", to: "/featured-house-plans" },
  },
  {
    number: "02",
    icon: "💳",
    title: "Make Payment",
    description:
      "Securely purchase your chosen plan online via Paystack. Fast, safe, and hassle-free — no hidden fees.",
    cta: null,
  },
  {
    number: "03",
    icon: "📦",
    title: "Receive Your Plan",
    description:
      "Get your complete, professionally stamped building plan delivered nationwide. Ready to submit to any regulatory authority.",
    cta: null,
  },
];

function HowItWorks() {
  return (
    <section className="pt-16 md:pt-24 pb-8 md:pb-10 font-Montserrat bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#1877F2] uppercase tracking-[0.3em] text-xs md:text-sm font-semibold mb-3">
            Simple Process
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3">
            How It Works
          </h2>
          <div className="w-12 h-1 bg-gradient-to-r from-[#1877F2] to-blue-400 rounded-full mx-auto mb-4" />
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Getting your professional building plan takes just three easy steps.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line (desktop) */}
          <div className="hidden md:block absolute top-12 left-[17%] right-[17%] h-0.5 bg-gradient-to-r from-[#1877F2] via-[#1877F2] to-[#1877F2] opacity-20" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
            {steps.map(({ number, icon, title, description, cta }, i) => (
              <div key={title} className="relative flex flex-col items-center text-center group">
                {/* Step circle */}
                <div className="w-24 h-24 rounded-full bg-[#FFF8EC] border-2 border-[#1877F2] flex flex-col items-center justify-center mb-5 group-hover:bg-[#1877F2] transition-colors duration-300 z-10">
                  <span className="text-2xl group-hover:scale-110 transition-transform duration-300">
                    {icon}
                  </span>
                  <span className="text-[10px] font-bold text-[#1877F2] group-hover:text-white mt-0.5 transition-colors duration-300">
                    STEP {number}
                  </span>
                </div>

                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
                  {title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed max-w-xs">
                  {description}
                </p>
                {cta && (
                  <Link
                    to={cta.to}
                    className="mt-4 text-[#1877F2] text-sm font-semibold hover:underline"
                  >
                    {cta.label} →
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <Link
            to="/featured-house-plans"
            className="inline-block bg-[#1877F2] hover:bg-[#0e5fc7] text-white font-semibold py-3 px-10 rounded-full transition-colors duration-200 text-sm md:text-base"
          >
            Start Browsing Plans
          </Link>
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
